import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";

import {
  ModalShell,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useModal,
} from "components/Modal";
import { Button } from "components/Button";
import { Radio } from "components/Radio";
import { RegularText } from "components/Text";
import { LoadingView, ErrorView } from "components/Feedback";

import { getErrorMessage } from "services/api";

import { getEmployeesGroups, reassignEmployee } from "./api";
import styles from "./styles.module.scss";

/** Назначение сотрудника на другую должность */
export const AssignEmployeeModal = ({ employee }) => {
  const queryClient = useQueryClient();
  const { closeModal } = useModal();

  const groupsQuery = useQuery(["employees-groups"], getEmployeesGroups);
  const groups = groupsQuery.data?.items ?? [];

  const [selectedId, setSelectedId] = useState(
    String(employee?.usersgroupid ?? "")
  );
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleAssign = async () => {
    if (!selectedId) return;
    setSaving(true);
    setError("");
    try {
      await reassignEmployee({
        usersgroupid: selectedId,
        usersid: employee.usersid,
      });
      queryClient.invalidateQueries(["employees"]);
      closeModal();
    } catch (e) {
      setError(getErrorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalShell width={400}>
      <ModalHeader title="Назначить на должность" onClose={closeModal} />
      <ModalBody className={styles.assignModalBody}>
        {groupsQuery.isLoading ? (
          <LoadingView />
        ) : groupsQuery.isError ? (
          <ErrorView
            message={getErrorMessage(groupsQuery.error)}
            onRetry={groupsQuery.refetch}
          />
        ) : (
          groups.map((group) => (
            <div className={styles.assignRadioRow} key={group.item.usersgroupid}>
              <Radio
                id={`assign-${group.item.usersgroupid}`}
                name="assign-group"
                label={group.item.name}
                checked={String(selectedId) === String(group.item.usersgroupid)}
                onChange={() => setSelectedId(String(group.item.usersgroupid))}
              />
            </div>
          ))
        )}
        {!!error && (
          <RegularText size={13} color="danger">
            {error}
          </RegularText>
        )}
      </ModalBody>
      <ModalFooter>
        <Button variant="tertiary" onClick={closeModal}>
          Отменить
        </Button>
        <Button
          variant="secondary"
          onClick={handleAssign}
          disabled={!selectedId}
          loading={saving}
        >
          Назначить
        </Button>
      </ModalFooter>
    </ModalShell>
  );
};
